import { Modal } from 'antd'

import { GuideDestroy } from '@/components/Guide'
import { CreateApiDestroy } from '@/utils/modal'
import { clearCurrentPageIknowArr } from '@/hooks/useIknow'
import * as Sentry from '@sentry/browser'
import { setPage, logger } from '@/utils/logger'
import { setTitleByPathname } from '@/utils/title'
import urlParse from '@/utils/urlParse'
import blockHistory from '@/utils/history/block'

const GlobalModel = {
    namespace: 'global',
    state: {
        collapsed: false,
        notices: [],
        showBackTop: false,
        customBackTop: undefined,
        supplierShopCurrentId: null, // 当前小站选择的那个供应商的id, 用户显示对应小程序码
        erpDownloadEl: null // GlobalHelper 组件是否展示erp下载按钮
    },
    effects: {
        *clearNotices({ payload }, { put, select }) {
            yield put({
                type: 'saveClearedNotices',
                payload
            })
            const count = yield select(state => state.global.notices.length)
            const unreadCount = yield select(state => state.global.notices.filter(item => !item.read).length)
            yield put({
                type: 'user/changeNotifyCount',
                payload: {
                    totalCount: count,
                    unreadCount
                }
            })
        },

        *changeNoticeReadState({ payload }, { put, select }) {
            const notices = yield select(state =>
                state.global.notices.map(item => {
                    const notice = { ...item }

                    if (notice.id === payload) {
                        notice.read = true
                    }

                    return notice
                })
            )
            yield put({
                type: 'saveNotices',
                payload: notices
            })
            yield put({
                type: 'user/changeNotifyCount',
                payload: {
                    totalCount: notices.length,
                    unreadCount: notices.filter(item => !item.read).length
                }
            })
        }
    },
    reducers: {
        changeLayoutCollapsed(
            state = {
                notices: [],
                collapsed: true
            },
            { payload }
        ) {
            return { ...state, collapsed: payload }
        },
        saveNotices(state, { payload }) {
            return {
                collapsed: false,
                ...state,
                notices: payload
            }
        },
        saveClearedNotices(
            state = {
                notices: [],
                collapsed: true
            },
            { payload }
        ) {
            return {
                collapsed: false,
                ...state,
                notices: state.notices.filter(item => item.type !== payload)
            }
        },
        setShowBackTop(state, { payload }) {
            let customBackTop
            if (payload && payload.customBackTop) {
                customBackTop = payload.customBackTop
            }
            return {
                ...state,
                showBackTop: !!payload,
                customBackTop
            }
        },
        setSiteSupplierId(state, { payload }) {
            return {
                ...state,
                supplierShopCurrentId: payload
            }
        },
        setErpDownloadEl(state, { payload }) {
            return {
                ...state,
                erpDownloadEl: payload
            }
        }
    },
    subscriptions: {
        setup({ history }) {
            blockHistory()

            urlParse.init()

            // 子应用切走，unListen未生效，导致子应用埋点执行了一次，导致container取值不对
            // 先加个变量解决这个问题
            let _unListen = false

            const unListen = history.listen(location => {
                if (_unListen) {
                    return
                }

                setPage(location)

                setTitleByPathname(location.pathname)

                logger.pushLocation()

                logger.pv()

                GuideDestroy()
                CreateApiDestroy()
                clearCurrentPageIknowArr()
            })

            window.onpopstate = () => {
                Modal.destroyAll()
            }
            Sentry.setTag('user.device_id', localStorage.getItem('device_id'))

            return () => {
                unListen()

                _unListen = true
            }
        }
    }
}

export default GlobalModel
